import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// Styles
import styles from './Tabs.module.scss'

const Tabs = ({ activeTab, children, onClick, className }) => {
  const handleOnClick = (e) => {
    e.preventDefault()
    onClick(e)
  }

  return (
    <>
      <ul className={classnames(styles.tabs, className)}>
        {children.map((child) => {
          if (child.type.displayName !== 'Tab') {
            throw new Error('Tab must be used within Tabs')
          }

          const enhancedTab = React.cloneElement(child, {
            key: child.props.label,
            activeTab,
            children,
            onClick: handleOnClick,
          })
          return enhancedTab
        })}
      </ul>
      <div>
        {children.map((child) => {
          if (child.props.label !== activeTab) return undefined
          return child.props.children
        })}
      </div>
    </>
  )
}

Tabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default Tabs
